import graphql__84f5b02c2746361d09e0 from "./__generated__/CityWalk_cityWalk.graphql.js";import { graphql, useFragment } from "react-relay";

import MapContextProvider from "../Maps/MapContext";
import CityWalkLayout from "./CityWalkLayout";

const CityWalk = props => {
  const cityWalk = useFragment(CityWalk_cityWalk, props.visualization);

  return (
    <MapContextProvider map={cityWalk}>
      <CityWalkLayout cityWalk={cityWalk} />
    </MapContextProvider>
  );
};

const CityWalk_cityWalk = graphql__84f5b02c2746361d09e0;

export default CityWalk;
